(() => {
  if (window.__dhCustomInitialized) return;
  window.__dhCustomInitialized = true;

  function getAnchorTarget(hash) {
    if (!hash || hash === '#') return null;
    try {
      return document.querySelector(hash);
    } catch (_error) {
      return null;
    }
  }

  function scrollToAnchor(hash) {
    const target = getAnchorTarget(hash);
    if (!target) return false;

    const header = document.querySelector('header, .header, #shopify-section-header');
    const headerHeight = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 100;
    window.scrollTo({ top, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash) {
      window.setTimeout(() => scrollToAnchor(window.location.hash), 500);
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href*="#"]');
      if (!link) return;

      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      if (!scrollToAnchor(url.hash)) return;

      event.preventDefault();
      window.history.pushState(null, '', url.hash);
    });
  });
})();
